const isNull = (v) => v === null || v === undefined
const isEmptyString = (v) => (typeof v === 'string' && v.trim() === '') || v === ''

export const required = (v) => (!isNull(v) && !isEmptyString(v)) || 'Obbligatorio'
export const number = (v) => typeof v === 'number' || 'Numero non valido'
export const positive = (v) => (typeof v === 'number' && v >= 0) || `Minimo 0`

export const min = (n) => (v) => (typeof v === 'number' && v >= n) || `Minimo ${n}`
export const max = (n) => (v) => (typeof v === 'number' && v <= n) || `Massimo ${n}`

// eslint-disable-next-line no-useless-escape
const emailRe = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
export const email = (v) => new RegExp(emailRe).test(v) || 'Indirizzo email non valido'

// eslint-disable-next-line no-useless-escape
const phoneNumberRe = /^((00|\+)39[\. ]??)??3\d{2}[\. ]??\d{6,7}$/
export const phoneNumber = (v) => new RegExp(phoneNumberRe).test(v) || 'Indirizzo email non valido'
